import React from 'react'
import { MultimediaPageProps } from '../../../../../../@types/props-types'
import { SCREEN_MULTIMEDIA, SCREENS } from '../../../../../../services/domain/wizardScreens'
import ScreenContainer from '../../../../../common/containers/screenContainer/ScreenContainer'
import { ScreenLayout } from '../../../../../common/containers/screenLayout/ScreenLayout'
import { useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { MultimediaUploaderType } from '../../../../../../@types/multimedia-types'
import AttachmentsWrapper from '../attachmentsWrapper/AttachmentsWrapper'
import './WebViewMultimedia.css'
import { useTranslation } from 'react-i18next'

const screen = SCREENS[SCREEN_MULTIMEDIA]

export const WebViewMultimedia: React.FC<MultimediaPageProps> = ({ onNavigate, allowedTypesToDisplay }) => {
  const { t } = useTranslation()

  const hasOnlyPictures =
    allowedTypesToDisplay.includes(MultimediaUploaderType.PICTURE) && allowedTypesToDisplay.length === 1
  const attachments = useAppSelector((state: InitState) => state.multimediaFeature.attachments)

  return (
    <>
      <ScreenContainer
        disableMarginBottom={true}
        containerId={screen.id}
        className='full-width-content'
        onNavigate={onNavigate}
        screen={screen}
      >
        <ScreenLayout id={`${screen.id}-mobile-tooltip`} headline={''} screenName={screen.name}>
          <AttachmentsWrapper
            hasOnlyPictures={hasOnlyPictures}
            multimediaContent={attachments}
            allowedTypesToDisplay={allowedTypesToDisplay}
          />
        </ScreenLayout>
      </ScreenContainer>
      <div className={`font-gray font-body-medium-regular padding-bottom-spacing-400 padding-top-spacing-400`}>
        {t('message.mandatory')}
      </div>
    </>
  )
}
